// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-uploader_card__RLkBN {
    color: var(--mui-palette-primary-900);
    background-color: var(--mui-palette-primary-200);
    border: none;
    margin-bottom: 8px;
    width: auto;
    padding: 12px 16px;
    font-size: 12px;
}

.file-uploader_spinner__Vqikp {
    margin-left: 8px;
    animation-name: file-uploader_spin__QXTx2;
    animation-duration: 2500ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
}

.file-uploader_uploadButton__Do-bP {
    margin-bottom: 8px;
    border-style: dashed;
}

.file-uploader_dropZone__rUmaQ {
  transition: all 0.2s ease;
}

.file-uploader_dropZone__rUmaQ.file-uploader_dragging__xTPro {
  background-color: rgba(0, 0, 0, 0.05);
  border: 2px dashed #666;
  border-radius: 4px;
  padding: 8px;
}

@keyframes file-uploader_spin__QXTx2 {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}`, "",{"version":3,"sources":["webpack://./../../packages/ui/dist/file-uploader/file-uploader.module.css"],"names":[],"mappings":"AAAA;IACI,qCAAqC;IACrC,gDAAgD;IAChD,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,yCAAoB;IACpB,0BAA0B;IAC1B,mCAAmC;IACnC,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;AACd;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ","sourcesContent":[".card {\n    color: var(--mui-palette-primary-900);\n    background-color: var(--mui-palette-primary-200);\n    border: none;\n    margin-bottom: 8px;\n    width: auto;\n    padding: 12px 16px;\n    font-size: 12px;\n}\n\n.spinner {\n    margin-left: 8px;\n    animation-name: spin;\n    animation-duration: 2500ms;\n    animation-iteration-count: infinite;\n    animation-timing-function: linear;\n}\n\n.uploadButton {\n    margin-bottom: 8px;\n    border-style: dashed;\n}\n\n.dropZone {\n  transition: all 0.2s ease;\n}\n\n.dropZone.dragging {\n  background-color: rgba(0, 0, 0, 0.05);\n  border: 2px dashed #666;\n  border-radius: 4px;\n  padding: 8px;\n}\n\n@keyframes spin {\n    from {\n        transform: rotate(0deg);\n    }\n\n    to {\n        transform: rotate(360deg);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `file-uploader_card__RLkBN`,
	"spinner": `file-uploader_spinner__Vqikp`,
	"spin": `file-uploader_spin__QXTx2`,
	"uploadButton": `file-uploader_uploadButton__Do-bP`,
	"dropZone": `file-uploader_dropZone__rUmaQ`,
	"dragging": `file-uploader_dragging__xTPro`
};
export default ___CSS_LOADER_EXPORT___;
